"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var Link = function Link(props, ref) {
  var to = props.to,
      icon = props.icon,
      className = props.className,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["to", "icon", "className", "children"]);
  var iconNode = null;

  if (icon) {
    var iconProps = {
      type: icon
    };

    if (icon.includes(':')) {
      var _icon$split = icon.split(':'),
          _icon$split2 = (0, _slicedToArray2.default)(_icon$split, 2),
          iconType = _icon$split2[0],
          variant = _icon$split2[1];

      iconProps = {
        type: iconType,
        variant: variant
      };
    }

    iconNode = React.createElement(_Icon.default, Object.assign({}, iconProps, {
      className: "Link__icon"
    }));
  }

  var Element;
  var elementProps = {};

  if (!to) {
    Element = 'button';
    elementProps.type = 'button';
  } else {
    Element = 'a';
    elementProps.href = to;
  }

  return React.createElement(Element, Object.assign({}, otherProps, elementProps, {
    className: (0, _classnames.default)(className, 'Link'),
    ref: ref
  }), iconNode, children && React.createElement("span", {
    className: "Link__content"
  }, children));
};

exports.Link = Link;

var _Link = React.forwardRef(Link);

_Link.defaultProps = {
  to: undefined,
  icon: undefined,
  className: undefined,
  children: undefined
};
_Link.propTypes = {
  to: _propTypes.default.string,
  icon: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = _Link;
exports.default = _default;